// @flow
import type {EnhancedOrder, EnhancedOrderItem, Order} from "../models";
import productService from "../../service/productService";
import reshipmentService from "../../reshipment/api/reshipmentService";
import {ReshipmentStatus} from "../../reshipment/model";
import {OrderStatus} from "../models";

const orderEnhancer = async (order: Order): Promise<EnhancedOrder> => {
	const partNumbers = order.localizedOrderItems.map(item => item.partNumber);
	const detailedProducts = await productService.getDetailedProducts(partNumbers, false, false, false);
	const orderReshipments = await reshipmentService.getReshipmentByOrderNumber(order.orderId);
	const activeReshipments = orderReshipments ? orderReshipments.filter(r =>
		r.status === ReshipmentStatus.REQUESTED || r.status === ReshipmentStatus.APPROVED || r.status === ReshipmentStatus.SENT
	) : [];
	const createdReshipment = orderReshipments ? orderReshipments.find(r => r.status === ReshipmentStatus.CREATED) : null;
	const localizedOrderItems: EnhancedOrderItem[] = await Promise.all(
		order.localizedOrderItems.map(async orderItem => {
			const detailedProduct = detailedProducts.find(product => product.partNumber === orderItem.partNumber);
			const name = detailedProduct ? detailedProduct.product.name : "";
			const hasValidBatchPriceForReshipment = await reshipmentService.validateBatchPriceForReshipment(orderItem.batchPrice);
			const alreadyReturnedAmount = activeReshipments.reduce((sum, r) =>
				sum + r.items
					.filter(item => item.partNumber === orderItem.partNumber)
					.reduce((itemSum, item) => itemSum + item.requestedAmount, 0), 0);
			const hasReshipment = !!createdReshipment?.items.find(item =>
				item.partNumber === orderItem.partNumber
			) || alreadyReturnedAmount >= orderItem.orderedQuantity;

			return {
				...orderItem,
				name,
				hasReshipment,
				hasValidBatchPriceForReshipment,
				alreadyReturnedAmount
			};
		})
	);
	const hasActiveReshipments = activeReshipments.length > 0;
	return {
		...order,
		items: localizedOrderItems,
		isReshipmentRequested: hasActiveReshipments,
		canBeReshipped: !!createdReshipment
			? true
			: (order.status === OrderStatus.PLACED || order.status === OrderStatus.PROCESSED || order.status === OrderStatus.SHIPPED)
	};
};

export default orderEnhancer;
